import { call, put, takeLatest } from "redux-saga/effects";
import { setVtrackLoader } from "../redux/actions/app-state";
import { getSessionAttendeeDetails as getSessionAttendeeDetailsApi } from "../http/requests/session";
import { SessionType, setSessionAttendeeDetails } from "../redux/actions/session";

function* workerGetSessionAttendeeDetails() {
  try {
    yield put(setVtrackLoader(true));
    const data = yield call(getSessionAttendeeDetailsApi);
    yield put(setSessionAttendeeDetails(data));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  } finally {
    yield put(setVtrackLoader(false));
  }
}

export function* getSessionAttendeeDetailsSaga() {
  yield takeLatest(SessionType.GET_SESSION_ATTENDEE_DETAILS, workerGetSessionAttendeeDetails);
}


